import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store.js';
import { api } from '../services/api-client.js';

export default function MobileEntryPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setAuth = useAuthStore((s) => s.setAuth);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('t');
    if (!token) {
      setError('Missing link token');
      return;
    }

    api.post<{ token: string; user: any; dealership: any }>('/auth/mobile-login', { token })
      .then((res) => {
        if (!res.success) {
          setError(res.error ?? 'Link expired');
          return;
        }
        setAuth(res.data!.token, res.data!.user, res.data!.dealership);
        navigate('/add', { replace: true });
      })
      .catch(() => setError('Network error'));
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-surface-900 text-white flex flex-col items-center justify-center px-6 text-center">
        <h1 className="text-xl font-bold mb-2">Link Expired</h1>
        <p className="text-surface-400 text-sm mb-6">{error}. Scan the QR code again from your dashboard.</p>
        <a href="/login" className="text-brand-400 text-sm font-medium">Or sign in manually</a>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface-900 text-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-brand-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-surface-400 text-sm">Connecting...</p>
      </div>
    </div>
  );
}
